import SettingService from '../settings/SettingService.js';

import React, { useContext, useEffect, useReducer } from 'react';

const SettingsContext = React.createContext({});
function useSettings() {
    return useContext(SettingsContext);
}
function useProvideSettings() {
    let local = localStorage.getItem("lthub_config");
    const [settings, setSettings] = useReducer((state, newState) => ({ ...state, ...newState }), local ? JSON.parse(local) : {});

    var loadSettings = function () {
        SettingService.getSettings()
            .then((response) => {
                if ('data' in response && 'data' in response.data) {
                    var updatedSettings = { ...settings };
                    var anyUpdate = false;
                    for (var name in response.data.data) {
                        var s = response.data.data[name];
                        if (s.name in updatedSettings) {
                            if (updatedSettings[s.name].settingValue != s.settingValue || updatedSettings[s.name].type != s.type) {
                                updatedSettings[s.name] = s;
                                setSettings({ [s.name]: s });
                                anyUpdate = true;
                            }
                        } else {
                            updatedSettings[s.name] = s;
                            setSettings({ [s.name]: s });
                            anyUpdate = true;
                        }
                    }
                    if (anyUpdate) {
                        //setSettings(updatedSettings);
                        localStorage.setItem("lthub_config", JSON.stringify(updatedSettings));
                        console.log("updated settings", updatedSettings);
                    } else {
                        console.log("local settings up to date");
                    }
                }
            })
            .catch(function (e) {

            }
            );
    };
    useEffect(loadSettings, []);//only run once

    const list = () => {
        return [...Object.values(settings)];
    };
    const get = (name) => {
        if (name in settings)
            return settings[name].settingValue;
        else return 0;
    };
    const set = (setting) => {
        setSettings({ [setting.name]: setting });
        return SettingService.updateSetting(setting);
    };

    return { get, set, list };
}

function ProvideSettings({ children }) {
    let settings = useProvideSettings();
    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
}

export default useSettings;
export { ProvideSettings };